/* eslint-disable no-lone-blocks */
import React, { Component } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TableComponent from '../../Layouts/TableComponent';
import swal from 'sweetalert';
import TextField from "@material-ui/core/TextField";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import ls from "local-storage";

class ExperienceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            experience: [],
            count: 0,
            isLoading: true,
            pageStatus: false,
            searchQuery: "",
            suggestions: [],
            tableTh: [
                { id: 'minExpYear', numeric: false, disablePadding: true, label: 'Min Experience (in years)', sortable: true },
                { id: 'maxExpYear', numeric: false, disablePadding: true, label: 'Max Experience (in years)', sortable: true },
                { id: 'created_at', numeric: false, disablePadding: true, label: 'Created On', sortable: true },
                { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
            ]
        }
        this.EexpData = this.EexpData.bind(this);
        this.removeExp = this.removeExp.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    }

    componentDidMount() {
        if (this.props && this.props.authToken === false) {
            // this.props.history.push('/login');
        }
        this.EexpData();
    }

    componentWillReceiveProps(props) {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }

    EexpData = async (e) => {
        this.setState({ isLoading: true });
        let exp = await AuthApi.getExperience();
        if (exp && exp.status === true) {
            this.setState({
                experience: exp.data,
                count: exp.data.length,
                isLoading: false,
            });
        } else {
            this.setState({
                experience: [],
                count: 0,
                isLoading: false,
            });
        }
    }

    async removeExp(id) {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: ["Cancel", "Yes"]
        }).then(async (confirm) => {
            if (confirm) {
                try {
                    let currentExperience = await AuthApi.deleteExperience(id);
                    if (currentExperience && currentExperience.status === true) {
                        this.setState({
                            pageStatus: true
                        })
                        this.EexpData();
                        swal("Success", "Experience deleted successfully!", "success");
                        setTimeout(
                            () => this.setState({ pageStatus: false }),
                            500
                        );
                    } else {
                        swal("Error", "Failed to delete experience.", "error");
                    }
                } catch (error) {
                    swal("Error", "Failed to delete experience.", "error");
                }
            }
        });
    }

    handleChange(e) {
        const searchQuery = e.target.value;
        const suggestions = this.state.experience.filter((item) => {
            return (
                item.minExpYear.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.maxExpYear.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.created_at.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
        this.setState({ searchQuery, suggestions }, this.handleSearch);
    }

    handleSearch = () => {
        // Trigger search functionality
        const filterExperience = this.state.experience.filter((item) => {
            return (
                item.minExpYear
                    .toString()
                    .toLowerCase()
                    .includes(this.state.searchQuery.toLowerCase()) ||
                item.maxExpYear
                    .toString()
                    .toLowerCase()
                    .includes(this.state.searchQuery.toLowerCase()) ||
                item.created_at
                    .toString()
                    .toLowerCase()
                    .includes(this.state.searchQuery.toLowerCase())
            );
        });
        this.setState({ filterExperience });
    };

    clearSearch = () => {
        this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
    };

    handleSuggestionClick = (suggestion) => {
        this.setState({ searchQuery: suggestion.minExpYear.toString(), suggestions: [] }, this.handleSearch);
    };

    render() {
        const classes = this.props;
        const filterExperience = this.state.filterExperience || this.state.experience;
        const isEmployeeRole = ls("roles") === "Employee";
        const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];
        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div style={{ marginBottom: "11%" }}>
                            <Card className={classes.root} style={{ marginBottom: '3%' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Experience"
                                        primaryPageLink="/experience"
                                        isSecondaryPage={false}
                                        secondaryPageName="" />
                                </CardContent>
                            </Card>
                            <TableComponent
                                {...this.props}
                                tableTh={this.state.tableTh}
                                tableData={filterExperience}
                                tableCount={filterExperience.length}
                                isLoading={this.state.isLoading}
                                tablePagestatus={this.state.pageStatus}
                                colNameToShow={['minExpYear', 'maxExpYear', 'created_at']}
                                openPopUp={false}
                                removeRow={this.removeExp}
                                actionBtns={[permissions.includes("Experience.Edit") && ('update'), permissions.includes("Experience.Delete") && ('delete')]}
                                modelName={'Experience'}
                                addRoute={isEmployeeRole ? false : '/experience/add'}
                                updateRoute={'/experience/edit'}
                                openPopUpUpdate={false}
                                extraHeaderContent={
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <TextField
                                            label="Search"
                                            value={this.state.searchQuery}
                                            onChange={this.handleChange}
                                            style={{
                                                marginRight: '0'
                                            }}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: this.state.searchQuery !== "",
                                                style: {
                                                    color: '#036dda',
                                                    transform: this.state.searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                                    transition: 'transform 0.2s ease-in-out'
                                                }
                                            }}
                                            InputProps={{
                                                style: {
                                                    backgroundColor: 'lightgray',
                                                    borderRadius: '25px',
                                                    height: "40px"
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {this.state.searchQuery && (
                                                            <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                                                        )}
                                                        <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {this.state.searchQuery && this.state.suggestions.length > 0 && (
                                            <Paper style={{
                                                position: 'absolute',
                                                top: '100%',
                                                right: '0',
                                                zIndex: 10,
                                                width: "207px",
                                                maxHeight: '200px',
                                                overflowY: 'auto',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                                backgroundColor: 'white'
                                            }}>
                                                {[...new Set(this.state.suggestions.map(suggestion => `${suggestion.minExpYear} - ${suggestion.maxExpYear}`))].map((expRange, index) => (
                                                    <MenuItem key={index} onClick={() => this.handleSuggestionClick({ minExpYear: expRange.split(' - ')[0] })} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                                                        {expRange}
                                                    </MenuItem>
                                                ))}
                                            </Paper>
                                        )}
                                    </div>
                                }
                            />
                        </div>
                    } />
                <Footer {...this.props} />
            </div >
        )
    }
}

export default ExperienceList;
